/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Input } from '@angular/core';
import { type ColumnDef, type TableConfig, CAPACITY_UNIT, I18nService, UtilService } from '@dm/core';
import { type Lun } from 'app/common/types/mo';

@Component({
    selector: 'app-unavailable-lun',
    templateUrl: './unavailable-lun.component.html',
    styleUrls: ['./unavailable-lun.component.scss'],
})
export class UnavailableLunComponent {
    @Input() luns: Lun[];

    tableConfig: TableConfig = {
        dataKey: 'ID',
    };

    columnDefs: ColumnDef[] = [
        {
            header: this.i18nService.get('common.name_column'),
            field: 'NAME',
        },
        {
            header: this.i18nService.get('common.ID_column'),
            field: 'ID',
        },
        {
            header: this.i18nService.get('common.capacity_column'),
            field: 'CAPACITY',
            render: (value: string): string => this.utilService.adaptUnit(value, CAPACITY_UNIT.SECTOR).label,
        },
    ];

    constructor(
        private i18nService: I18nService,
        private utilService: UtilService,
    ) {}
}
